import React from "react";
import { lighten, CircularProgress } from "@mui/material";
import { circularProgressSizeProps } from "../../../utils.js";
const MuiLoadingButton = {
  defaultProps: {
    loadingIndicator: /* @__PURE__ */ React.createElement(
      CircularProgress,
      {
        color: "inherit",
        size: circularProgressSizeProps.extraSmall.size,
        thickness: circularProgressSizeProps.extraSmall.thickness,
        disableShrink: true
      }
    )
  },
  styleOverrides: {
    loadingIndicatorCenter: ({ theme, ownerState }) => ({
      color: theme.palette.common.white,
      ...ownerState.variant === "outlined" && {
        color: lighten(theme.palette.primaryShadowed.main, 0.4)
      }
    })
  }
};
export {
  MuiLoadingButton
};
//# sourceMappingURL=MuiLoadingButton.js.map
